export const setAllInvestorDetails=(data)=>{
    return {
        type: "SET_ALL_INVESTOR_DETAILS",
        info: data,
    }
}
export const nullAllInvestorDetails=()=>{
    return{
        type:"NULL_ALL_INVESTOR_DETAILS",
        info: null
    }
}
export const getAllInvestorDetails=()=>{
    return {
        type: "GET_ALL_INVESTOR_DETAILS",
        
    }
}
